<template>
  <ul class="ten-select-group__wrap">
    <li class="ten-select-group__title">{{ label }}</li>
    <li>
      <ul class="ten-select-group">
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    label: String,
  },
};
</script>
